import script from "./RegistrationCultureExportTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCultureExportTable.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationCultureExportTable.vue?vue&type=style&index=0&id=7f1b7747&lang=scss"

const __exports__ = script;

export default __exports__